// JavaScript for Product Image Zoom Effect
document.addEventListener('DOMContentLoaded', function () {
  // Initialize zoom functionality
  function initImageZoom() {
    const mainImageContainer = document.querySelector(
      '.main-thumbnail-for-product'
    );
    const mainImage = document.getElementById('product-main-image');
    const thumbnails = document.querySelectorAll('.product-thumbnail');

    if (!mainImage || !mainImageContainer) return;

    // Create zoom elements
    createZoomElements(mainImageContainer, mainImage);

    // Setup thumbnail click handlers
    setupThumbnailHandlers(thumbnails, mainImage);

    // Setup variant change handler
    setupVariantHandler();
  }

  function createZoomElements(container, mainImage) {
    // Wrap main image in container
    if (!container.querySelector('.product-image-container')) {
      const imageContainer = document.createElement('div');
      imageContainer.className = 'product-image-container';

      // Move image into container
      const parent = mainImage.parentNode;
      parent.insertBefore(imageContainer, mainImage);
      imageContainer.appendChild(mainImage);

      // Create zoom lens
      const zoomLens = document.createElement('div');
      zoomLens.className = 'zoom-lens';
      imageContainer.appendChild(zoomLens);

      // Create zoom result
      const zoomResult = document.createElement('div');
      zoomResult.className = 'zoom-result';
      const zoomImage = document.createElement('img');
      zoomImage.src = mainImage.src;
      zoomImage.alt = mainImage.alt;
      zoomResult.appendChild(zoomImage);
      imageContainer.appendChild(zoomResult);

      // Create mobile overlay
      const overlay = document.createElement('div');
      overlay.className = 'zoom-overlay';
      document.body.appendChild(overlay);

      // Setup zoom events
      setupZoomEvents(
        imageContainer,
        mainImage,
        zoomLens,
        zoomResult,
        zoomImage,
        overlay
      );
    }
  }

  function setupZoomEvents(
    container,
    mainImage,
    lens,
    result,
    resultImage,
    overlay
  ) {
    let isZooming = false;

    // Mouse enter - show zoom
    container.addEventListener('mouseenter', function () {
      if (window.innerWidth > 992) {
        lens.classList.add('active');
        result.classList.add('active');
        isZooming = true;

        // Preload high-res image
        const highResImg = new Image();
        highResImg.onload = function () {
          resultImage.src = this.src;
          setupImageDimensions();
        };
        highResImg.src =
          mainImage.src.replace('_large', '_2048x2048') || mainImage.src;
      }
    });

    // Mouse leave - hide zoom
    container.addEventListener('mouseleave', function () {
      lens.classList.remove('active');
      result.classList.remove('active');
      isZooming = false;
    });

    // Mouse move - update zoom position
    container.addEventListener('mousemove', function (e) {
      if (isZooming && window.innerWidth > 992) {
        updateZoomPosition(e, container, lens, result, resultImage);
      }
    });

    // Touch events for mobile
    container.addEventListener('touchstart', function (e) {
      if (window.innerWidth <= 992) {
        e.preventDefault();
        showMobileZoom(mainImage, result, resultImage, overlay);
      }
    });

    // Close mobile zoom
    overlay.addEventListener('click', function () {
      hideMobileZoom(result, overlay);
    });

    function setupImageDimensions() {
      resultImage.onload = function () {
        const containerRect = container.getBoundingClientRect();
        const resultRect = result.getBoundingClientRect();

        // Calculate zoom ratios
        const zoomRatioX = this.naturalWidth / containerRect.width;
        const zoomRatioY = this.naturalHeight / containerRect.height;

        // Store ratios for mouse move calculations
        result.dataset.zoomRatioX = zoomRatioX;
        result.dataset.zoomRatioY = zoomRatioY;
      };
    }
  }

  function updateZoomPosition(e, container, lens, result, resultImage) {
    const containerRect = container.getBoundingClientRect();
    const lensSize = 120;

    // Calculate cursor position relative to image
    const x = e.clientX - containerRect.left;
    const y = e.clientY - containerRect.top;

    // Update lens position
    lens.style.left = x + 'px';
    lens.style.top = y + 'px';

    // Calculate zoom image position
    const zoomRatioX = parseFloat(result.dataset.zoomRatioX) || 2;
    const zoomRatioY = parseFloat(result.dataset.zoomRatioY) || 2;

    const moveX = x * zoomRatioX - result.offsetWidth / 2;
    const moveY = y * zoomRatioY - result.offsetHeight / 2;

    resultImage.style.left = -moveX + 'px';
    resultImage.style.top = -moveY + 'px';
  }

  function showMobileZoom(mainImage, result, resultImage, overlay) {
    // Load high-res image
    const highResImg = new Image();
    highResImg.onload = function () {
      resultImage.src = this.src;
      resultImage.style.width = '100%';
      resultImage.style.height = '100%';
      resultImage.style.objectFit = 'contain';
      resultImage.style.left = '0';
      resultImage.style.top = '0';
    };
    highResImg.src =
      mainImage.src.replace('_large', '_2048x2048') || mainImage.src;

    overlay.classList.add('active');
    result.classList.add('active');
  }

  function hideMobileZoom(result, overlay) {
    overlay.classList.remove('active');
    result.classList.remove('active');
  }

  function setupThumbnailHandlers(thumbnails, mainImage) {
    thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', function (e) {
        e.preventDefault();

        // Remove active class from all thumbnails
        thumbnails.forEach(t => t.classList.remove('active'));

        // Add active class to clicked thumbnail
        this.classList.add('active');

        // Update main image
        const newImageSrc = this.getAttribute('data-image');
        if (newImageSrc) {
          mainImage.src = newImageSrc;

          // Update zoom result image
          const zoomResultImg = document.querySelector('.zoom-result img');
          if (zoomResultImg) {
            zoomResultImg.src =
              newImageSrc.replace('_large', '_2048x2048') || newImageSrc;
          }
        }
      });
    });
  }

  function setupVariantHandler() {
    const variantSelect = document.getElementById('variant-select');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        const selectedOption = this.options[this.selectedIndex];
        const variantImage = selectedOption.getAttribute('data-image');

        if (variantImage) {
          const mainImage = document.getElementById('product-main-image');
          if (mainImage) {
            mainImage.src = variantImage;

            // Update zoom result image
            const zoomResultImg = document.querySelector('.zoom-result img');
            if (zoomResultImg) {
              zoomResultImg.src =
                variantImage.replace('_large', '_2048x2048') || variantImage;
            }
          }
        }
      });
    }
  }

  // Initialize zoom when page loads
  initImageZoom();

  // Reinitialize if images are dynamically loaded
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList') {
        const addedNodes = Array.from(mutation.addedNodes);
        const hasImages = addedNodes.some(
          node =>
            node.nodeType === 1 &&
            (node.tagName === 'IMG' || node.querySelector('img'))
        );

        if (hasImages) {
          setTimeout(initImageZoom, 100);
        }
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
